// TODO: Remove when unsupported browser redirecting is happening server side
import browsers from './definitions';


class CurrentBrowser {
  constructor(userAgent, browserBaselines, options) {
    this.browserBaselines = browserBaselines;
    this.init(browserBaselines);
    this.userAgent = userAgent || null;
    this.options = options || {};
    this.browserArgs = this.formatBrowserArgs(browserBaselines);
    this.isBrowserSupported = this.isBrowserSupported();
    this.browserName = '';
    this.browserVersion = '';
  }

  init() {
    if (!this.browserBaselines) {
      throw new Error('Must provide browser version baselines');
    }
  }

  getBrowserFromUserAgent() {
    return browsers.find(browser => browser[1].test(this.userAgent));
  }

  setNameAndVersion(foundBrowser) {
    const foundBrowserMatch = foundBrowser[1].exec(this.userAgent);
    const version = foundBrowserMatch && foundBrowserMatch[1].split(/[._]/).slice(0, 3);
    const minorVersion = version.slice(1).join('') || 0;

    this.browserName = String(foundBrowser[0]);
    this.browserVersion = Number(`${version[0]}.${minorVersion}`);
  }

  formatBrowserArgs() {
    return this.browserBaselines.map(browserString => ({
      name: String(browserString.split(' ')[0]).toLowerCase(),
      version: Number(browserString.split(' ')[1]),
    }));
  }

  isBrowserSupported() {
    if (!this.userAgent) {
      return this.options.allowNoUserAgent;
    }

    const foundBrowser = this.getBrowserFromUserAgent();

    if (!foundBrowser) {
      return false;
    }

    this.setNameAndVersion(foundBrowser);

    const matchedBrowserBaseline = this.browserArgs
      .find(browserArg => this.browserName === browserArg.name);

    return !!matchedBrowserBaseline && (this.browserVersion - matchedBrowserBaseline.version > 0);
  }
}

export default CurrentBrowser;
